import styled from 'styled-components';

export const WrapperModalEncuestaSatisfaccion = styled.div`
  .modal {
    position: fixed; /* Stay in place */
    z-index: 10;
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  /* Modal Content/Box */
  .modal-content {
    background-color: #fefefe;
    margin: 0 auto;
    border: 1px solid #888;
    border-radius: 5px;
    width: 57.5%;
    position: relative;
  }

  .divfooter button {
    margin: 0 auto;
    padding: 0.75rem 3.5rem;
  }

  .barraTop button {
    position: absolute;
    right: 0;
    top: 10px;
  }

  .modalCard {
    padding: 1rem !important;
  }

  .titulo,
  .modalCard > div {
    border: 0 !important;
  }

  .titulo > h1 {
    font-weight: 500;
    font-size: 25px !important;
    width: 95%;
  }

  .cardSiguiente {
    padding-top: 0 !important;
  }

  .siguiente button span {
    text-decoration: none !important;
  }

  .siguiente {
    display: flex;
    justify-content: flex-end;
    padding-right: 0rem;
    margin-right: 0rem;
    width: 100%;
  }

  .siguiente button::after {
    content: '>';
    font-size: 27px;
    font-weight: 500;
    position: relative;
    left: 10px;
    top: -2px;
  }

  .tituloModal {
    padding-top: 1.75rem !important;
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .botonTerminar {
    color: white !important;
    background-color: rgb(232, 30, 43) !important;
    min-width: 180px;
    -webkit-box-pack: center;
    justify-content: center;
    border: 1px solid #e81e2b;
    position: relative;
    border-radius: 4px;
    padding: 0.5rem 1rem;
    min-height: 48px;
    font-weight: 500;
    font-family: "Ubuntu";
    font-size: .875rem;
    align-items: center;
    display: flex;
    box-shadow: 0 2px 4px 0 rgb(30 30 30 / 35%);
    outline: none!important;
    transition: background .3s ease;
    margin-right: 0.5rem;
  }

  .botonTerminar:hover, .botonTerminar:active {
    background-color: #e81e2b;
    color: #fff;
  }

  .botonTerminar:disabled {
    background-color: #d4d4d4 !important;
    color: #ffffff;
    box-shadow: none;
  }

  .botonTerminar:after {
    content: none !important;
  }

  .botonContinuar {
    font-size: 15px;
    font-weight: 500;
  }

  .botonContinuar:disabled {
    background-color: #fefefe;
    color: #d4d4d4;
  }

  @media (max-width: 426px) {
    .barraTop {
      position: relative;
      float: right;
      top: -10px;
      right: -20px;
    }

    .barraTop button {
      margin: unset;
      position: unset;
      top: unset;
    }

    .divfooter button {
      margin: 0 auto;
      padding: 0.75rem 3.5rem;
      width: 60%;
    }

    .modalCard {
      display: flex;
      text-align: initial;
    }

    .modal-content {
      width: 100%;
    }

    .modal-content {
      position: initial;
      max-width: 100%;
    }

    .botonTerminar {
      margin-left: 0.5rem !important;
    }

    .titulo > h1 {
      font-size: 22px !important;
    }
  }

  @media (max-width: 376px) {
    .barraTop button {
      margin: 103px -130px;
    }
    
    .divfooter button {
      margin: 0 auto;
      padding: 0.75rem 3.5rem;
      width: 65%;
    }

    .modalCard {
      display: flex;
      text-align: initial;
    }

    .modal-content {
      position: initial;
      max-width: 100%;
    }

    .BoikB .modal button {
      margin-left: 24px;
    }
  }

  @media (max-width: 320px) {
    .barraTop button {
      margin: -10px -119px;
      position: initial;
      top: calc(50% - 203px);
      left: calc(50% + 242px);
      margin-left: -19px;
    }

    .divfooter button {
      margin: 0 auto;
      padding: 0.75rem 3.5rem;
      width: 75%;
    }

    .modalCard {
      display: flex;
      text-align: initial;
    }
    
    .modal-content {
      position: initial;
      max-width: 100%;
    }
  }
`;

export default WrapperModalEncuestaSatisfaccion;
